<template>
  <el-row>
    <el-row type="flex" justify="center">
      <el-form class="mobile-verification" :rules="rules" label-position="right" label-width="80px"
               :model="mobileVerification" ref="mobileVerification">
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="mobileVerification.phone" placeholder="手机号"
                    @keyup.native.enter="onSubmit"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="verificationCode">
          <el-input v-model="mobileVerification.verificationCode" placeholder="验证码"
                    @keyup.native.enter="onSubmit">
            <el-button slot="append" type="primary" @click="onVerify" :loading="veribtn.loading"
                       :disabled="veribtn.disabled">{{veribtn.sendmessage}}
            </el-button>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" :loading="submitbtn.loading" size="cons">确定</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="8">
        <div class="bottom-tips">
          <p><strong>没收到短信验证码?</strong></p>
          1、网络通讯异常可能会造成短信丢失，请重新获取或稍后再试。<br>
          2、请核实手机是否已欠费停机，或者屏蔽了系统短信。<br>
          3、如果手机已丢失或停用， 请选择其他验证方式 。<br>
          4、您也可以尝试将SIM卡移动到另一部手机，然后重试。
        </div>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import { generateVericode, verify, isRegistered } from 'api/MobileVeriCode'

const TIME_COUNT = 30

export default {
  data () {
    return {
      currentSteps: 1,
      veribtn: {
        loading: false,
        sendmessage: '发送短信验证码',
        disabled: false,
        count: '',
        timer: null,
      },
      submitbtn: {
        loading: false,
      },
      mobileVerification: {
        phone: '',
        verificationCode: '',
      },
      rules: {
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {
            // 手机号正则表达式，以后可更新
            pattern: /^1(3[0-9]|4[57]|5[0-35-9]|7[0135678]|8[0-9])\d{8}$/,
            message: '请输入中国大陆手机号',
            trigger: 'blur',
          },
        ],
        verificationCode: [
          {required: true, message: '请输入手机验证码', trigger: 'blur'},
        ],
      },
    }
  },
  props: ['steps'],
  methods: {
    async onSubmit () {
      this.$refs.mobileVerification.validate(async valid => {
        if (!valid) return
        try {
          this.submitbtn.loading = true
          await verify(this.mobileVerification)
          this.submitbtn.loading = false
          this.$message.success('验证成功')
          this.$emit('update:steps', this.currentSteps + 1)
        } catch (e) {
          this.$handleError(e)
          this.submitbtn.loading = false
        }
      })
    },
    async onVerify () {
      console.log(this.$refs)
      this.$refs.mobileVerification.validateField('phone', async valid => {
        if (valid) return
        try {
          this.veribtn.loading = true
          await isRegistered(this.mobileVerification)
          this.veribtn.loading = false
          await generateVericode(this.mobileVerification)
          this.$message.success('获取验证码成功')
          if (!this.veribtn.timer) {
            this.veribtn.count = TIME_COUNT
            this.veribtn.disabled = true
            this.veribtn.sendmessage = '重新获取(' + TIME_COUNT + 's)'
            this.veribtn.timer = setInterval(() => {
              if (this.veribtn.count > 0 && this.veribtn.count <= TIME_COUNT) {
                this.veribtn.count--
                this.veribtn.sendmessage = '重新获取(' + this.veribtn.count + 's)'
              } else {
                this.veribtn.disabled = false
                this.veribtn.sendmessage = '发送短信验证码'
                clearInterval(this.veribtn.timer)
                this.veribtn.timer = null
              }
            }, 1000)
          }
        } catch (e) {
          this.$handleError(e)
          this.veribtn.loading = false
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import "src/scss/var/colors";

.mobile-verification {
  margin-top: 60px;
}

.bottom-tips {
  background-color: #fffbed;
  border: 1px solid #f9efd3;
  padding: 10px 30px 20px;
  font-size: 0.8em;
}
</style>



// WEBPACK FOOTER //
// src/components/password/step1.vue